import { HttpClient, HttpParams } from '@angular/common/http';
import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';

import { setFieldObjectId } from 'src/app/shared/utils';

export abstract class ApplicationApiService {
  protected http: HttpClient;
  protected router: Router;

  constructor(protected injector: Injector) {
    this.http = injector.get(HttpClient);
    this.router = this.injector.get(Router);
  }

  protected createHttpParams(data: any): HttpParams {
    let params = new HttpParams();
    if (data == null) { return params; }

    Object.keys(data).forEach(key => {
      const value = data[key];

      if (Array.isArray(value)) {
        value.forEach(item => {
          params = params.has(key) ? params.append(key, item) : params.set(key, item);
        });
      } else {
        params = params.set(key, data[key]);
      }
    });
    return params;
  }

  protected handleError(error: any): Observable<any> {
    console.log('ERRO NA REQUISIÇÃO => ', error);

    // O encerramento da sessão é decidido exclusivamente no AuthInterceptor,
    // que compara o token da requisição com o token atual. Fazer navegação
    // também aqui permitiria que o 401 de uma requisição antiga expulsasse o
    // usuário logo após um relogin válido.
    return throwError(() => error);
  }

  protected setFieldObjectId(obj, field: string): any {
    return setFieldObjectId(obj, field);
  }
}
